import { render, staticRenderFns } from "./PartnerFormCompanyData.vue?vue&type=template&id=81f40f16&scoped=true&"
import script from "./PartnerFormCompanyData.vue?vue&type=script&lang=ts&"
export * from "./PartnerFormCompanyData.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerFormCompanyData.vue?vue&type=style&index=0&id=81f40f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f40f16",
  null
  
)

export default component.exports